export const PREFIX_TEAM_URL = 'team'
export const PREFIX_COMPANY_URL = 'company'